import { connect } from 'react-redux'
import BtoBLayout from '../../components/layout/BtoBLayout'


export default connect(null, null)(BtoBLayout)



// WEBPACK FOOTER //
// ./src/btob/containers/layout/BtoBLayoutContainer.js